import type { GetSummaryResponse } from "@montatec/contracts";
import { get } from "../../lib/fetch";


export const summaryService = {
    get: async () => await get<GetSummaryResponse>(`/api/providers/summary`).then(res => res.data),    
}